import api from "../../index.js";

export const GetIBTreeApi = (userId) => api.get(`UserMaster/IBTree-GetAllUserById/${userId}`);